import { Pagination } from '@/modules/shared/schemas/Pagination'

import { axios, Response } from '../index'
import { AccessProfile, PersonaStatus } from '../operators/get-clinic-operators'

export interface Therapist {
  id: string
  name: string
  avatarName: string
  avatar: string
  accessProfiles: AccessProfile[]
  automationGroupTherapists: AutomationGroupTherapist[]
  personaStatus: PersonaStatus
  specialties: AccessProfile[]
  invitation: Invitation | null
}

export interface Invitation {
  id: string
  personaId: string
  email: string
  pending: boolean
}

export interface AutomationGroupTherapist {
  id: string
  userId: number
  accessProfileId: number
  personaId: string
  used: boolean
  groupCategory: string
}

export default async function getClinicTherapists({
  page = 0,
  size = 10,
  personaName,
  accessProfileId,
  personaStatus
}: {
  page?: number
  size?: number
  personaName?: string
  accessProfileId?: number
  personaStatus?: PersonaStatus
} = {}): Response<Pagination<Therapist[]>> {
  const searchParams = new URLSearchParams()
  searchParams.set('page', page.toString())
  searchParams.set('size', size.toString())
  if (personaName) searchParams.set('personaName', personaName)
  if (accessProfileId)
    searchParams.set('accessProfileId', accessProfileId.toString())
  if (personaStatus) searchParams.set('personaStatus', personaStatus)

  return await axios.get(`/v2/therapists?${searchParams.toString()}`)
}
